export default class HomeBlockItem {
    
    constructor(data) {
        this._num      = null;
        this._likes    = null;
        this._name     = null;
        this._subtitle = null;
        this._label    = null;
        this._image    = null;
        this._imagex2  = null;
        this._url      = null;
        this._price    = null;
        this._timer    = null;
        this._priceCrossed = null;
        this._description  = null;
        this.init(data);
    }

    init(data) {
        for (var key in data) {
            this[key] = data[key];
        }
    }

    set numeration(value){
        this._num = value;
    }
    
    get numeration(){
        return this._num;
    }

    set likes(value){
        this._likes = value;
    }
    
    get likes(){
        return this._likes;
    }

    set name(value){
        this._name = value;
    }
    
    get name(){
        return this._name;
    }

    set subtitle(value){
        this._subtitle = value;
    }
    
    get subtitle(){
        return this._subtitle;
    }

    set image(value){
        this._image = value;
    }
    
    get image(){
        return this._image;
    }

    set imagex2(value){
        this._imagex2 = value;
    }
    
    get imagex2(){
        return this._imagex2;
    }

    set url(value){
        this._url = value;
    }
    
    get url(){
        return this._url;
    }

    set price(value){
        this._price = value;
    }
    
    get price(){
        return this._price;
    }

    set priceCrossed(value){
        this._priceCrossed = value;
    }
    
    get priceCrossed(){
        return this._priceCrossed;
    }

    set timeCounter(value){
        this._timer = value;
    }
    
    get timeCounter(){
        return this._timer;
    }

    set label(value){
        this._label = value;
    }
    
    get label(){
        return this._label;
    }

    set description(value){
        this._description = value;
    }
    
    get description(){
        return this._description;
    }
}